import set from 'lodash.set';

export const groupByProject = videoEdges =>
  videoEdges.reduce((acc, {node}) => {
    const {
      project: {id, name},
    } = node;

    if (!acc[id]) {
      acc[id] = {name, id, media: []}; // eslint-disable-line no-param-reassign
    }

    const nextIndex = acc[id].media.length;

    return set(acc, [id, 'media', `${nextIndex}`], node);
  }, {});



// WEBPACK FOOTER //
// ./src/lib/videos.js